import { Schema } from "@effect/schema";
import { Context } from "effect";
import type { RedisClientType } from "redis";
import { BaseError } from "./error";

export type KvJsonMeta = typeof KvJsonMeta.Type;
export type KvJsonMetaEncoded = typeof KvJsonMeta.Encoded;

export const KvJsonMeta = Schema.Struct({
  $lastUpdated: Schema.String,
}).annotations({ identifier: "KvJsonMeta" });

export function getLastUpdated(): string {
  return new Date().toISOString();
}

export class MetricsKvService extends Context.Tag("MetricsKvService")<
  MetricsKvService,
  RedisClientType | null
>() {}

export class MetricsKvError extends BaseError {
  readonly _tag = "MetricsKvError";
}
